const props = {
  // 基本信息
  changeRecord: {
    title: '工商变更',
    props: [
      { label: '变更时间', prop: 'changeTime' },
      { label: '变更项目', prop: 'changeItem' },
      { label: '变更前', prop: 'contentBefore', width: '280' },
      { label: '变更后', prop: 'contentAfter', width: '280' }
    ]
  },
  executive: {
    title: '主要高管',
    showHeader: false,
    props: [
      { label: '职位', prop: 'join', className: 'table-highlight-row' },
      { label: '姓名', prop: 'name' },
      { label: '职位', prop: 'join1', className: 'table-highlight-row' },
      { label: '姓名', prop: 'name1' }
    ]
  },
  investment: {
    title: '对外投资',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '被投资公司名称', prop: 'name' },
      { label: '投资数额', prop: 'amount' },
      { label: '投资占比', prop: 'percent' },
      { label: '注册时间', prop: 'estiblishTime', customKey: '$timestamp' },
      { label: '状态', prop: 'regStatus' },
      { label: '被投资法定代表人', prop: 'legalPersonName' }
    ]
  },
  shareholder: {
    title: '股东信息',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '股东', prop: 'name' },
      { label: '出资比例', prop: 'percent' },
      { label: '认缴出资', prop: 'amomon' },
      { label: '出资时间', prop: 'time' }
    ]
  },
  // 公司经营
  abnormal: {
    title: '经营异常',
    props: [
      { label: '列入经营异常原因', prop: 'putReason' },
      { label: '列入日期', prop: 'putDate', customKey: '$timestamp' },
      { label: '列入决定机关', prop: 'putDepartment' },
      { label: '移出经营异常原因', prop: 'removeReason' },
      { label: '移出日期', prop: 'removeDate', customKey: '$timestamp' },
      { label: '移出决定机关', prop: 'removeDepartment' }
    ]
  },
  punishment: {
    title: '行政处罚',
    props: [
      { label: '决定日期', prop: 'decisionDate', customKey: '$timestamp' },
      { label: '决定文书号', prop: 'punishNumber' },
      { label: '违法行为类型', prop: 'type' },
      { label: '处罚内容', prop: 'content' },
      { label: '决定机关', prop: 'departmentName' }
    ]
  },
  equity: {
    title: '股权质押',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '公告时间', prop: 'regDate', customKey: '$timestamp' },
      { label: '登记编号', prop: 'regNumber' },
      { label: '出质人', prop: 'pledgor' },
      { label: '质权人', prop: 'pledgee' },
      { label: '状态', prop: 'state' }
    ]
  },
  mortgage: {
    title: '动产抵押',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '登记日期', prop: 'regDate' },
      { label: '登记号', prop: 'regNum' },
      { label: '被担保债权类型', prop: 'type' },
      { label: '被担保债权数额', prop: 'amount' },
      { label: '登记机关', prop: 'regDepartment' },
      { label: '状态', prop: 'status' }
    ]
  },
  ownTax: {
    title: '欠税公告',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '发布日期', prop: 'publishDate', customKey: '$timestamp' },
      { label: '纳税人识别号', prop: 'taxIdNumber' },
      { label: '欠税税种', prop: 'taxCategory' },
      { label: '当前发生的欠税额', prop: 'newOwnTaxBalance' },
      { label: '欠税余额', prop: 'ownTaxBalance' },
      { label: '税务机关', prop: 'department' }
    ]
  },
  illegal: {
    title: '严重违法',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '列入日期', prop: 'putDate', customKey: '$timestamp' },
      { label: '列入原因', prop: 'putReason' },
      { label: '列入决定机关', prop: 'putDepartment' },
      { label: '移出日期', prop: 'removeDate', customKey: '$timestamp' },
      { label: '移出原因', prop: 'removeReason' },
      { label: '移出决定机关', prop: 'removeDepartment' }
    ]
  },
  license: {
    title: '行政许可证',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '许可书文编号', prop: 'licenceNumber' },
      { label: '许可文件名称', prop: 'licenceName' },
      { label: '有效期自', prop: 'fromDate' },
      { label: '有效期至', prop: 'toDate' },
      { label: '许可机关', prop: 'department' },
      { label: '许可内容', prop: 'scope' }
    ]
  },
  certificate: {
    title: '业务资质',
    pageHand: true,
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '证书类型', prop: 'certificateName' },
      { label: '证书编号', prop: 'certNo' },
      { label: '发证日期', prop: 'startDate' },
      { label: '截止日期', prop: 'endDate' }
    ]
  },
  // 知识产权
  trademark: {
    title: '商标信息',
    pageHand: true,
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '申请日期', prop: 'appDate', customKey: '$timestamp' },
      { label: '商标名称', prop: 'tmName' },
      { label: '注册号', prop: 'regNo' },
      { label: '类别', prop: 'intCls' },
      { label: '状态', prop: 'status' }
    ]
  },
  copyright: {
    title: '软件著作权',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '软件名称', prop: 'fullName' },
      { label: '登记日期', prop: 'regTime', customKey: '$timestamp' },
      { label: '软件简称', prop: 'simpleName' },
      { label: '登记号', prop: 'regNum' },
      { label: '著作权人', prop: 'authorNationality' }
    ]
  },
  patent: {
    title: '专利信息',
    pageHand: true,
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '名称', prop: 'patentName' },
      { label: '类型', prop: 'patentType' },
      { label: '申请公布号', prop: 'applicationPublishNum' },
      { label: '申请号', prop: 'patentNum' },
      { label: '申请公布日', prop: 'applicationPublishTime' }
    ]
  },
  icp: {
    title: '网站备案',
    pageHand: true,
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '网站名', prop: 'webName' },
      { label: '网站首页', prop: 'webSite', customKey: '$link' },
      { label: '审核时间', prop: 'examineDate' },
      { label: '备案号', prop: 'liscense' },
      { label: '主办单位性质', prop: 'companyType' }
    ]
  },
  // 涉诉风险
  openNotice: {
    title: '开庭公告',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '开庭日期', prop: 'startDate', customKey: '$timestamp' },
      { label: '案由', prop: 'caseReason' },
      { label: '案号', prop: 'caseNo' },
      { label: '原告/上诉人', prop: 'plaintiff' },
      { label: '被告/被上诉人', prop: 'defendant' },
      { label: '法庭', prop: 'courtroom' }
    ]
  },
  lawSuit: {
    title: '法律诉讼',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '日期', prop: 'judgementDate' },
      { label: '案号', prop: 'caseNumber' },
      { label: '类型', prop: 'caseType' },
      { label: '案件', prop: 'title' }
    ]
  },
  execute: {
    title: '被执行信息',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '立案时间', prop: 'caseCreateTime', customKey: '$timestamp' },
      { label: '执行标的', prop: 'execMoney' },
      { label: '案号', prop: 'caseCode' },
      { label: '执行法院', prop: 'execCourtName' }
    ]
  },
  dishonest: {
    title: '失信人信息',
    pageHand: true,
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '立案时间', prop: 'regDate', customKey: '$timestamp' },
      { label: '案号', prop: 'caseCode' },
      { label: '执行法院', prop: 'courtName' },
      { label: '履行状态', prop: 'performance' },
      { label: '执行依据文号', prop: 'gistId' }
    ]
  },
  judicial: {
    title: '司法协助',
    props: [
      { label: '序号', prop: '$index', width: '60' },
      { label: '被执行人', prop: 'executedPerson' },
      { label: '股权数额', prop: 'equityAmount' },
      { label: '执行法院', prop: 'executiveCourt' },
      { label: '执行通知文号', prop: 'executeNoticeNum' },
      { label: '类型|状态', prop: 'typeState' }
    ]
  }
}

export default Object.freeze(props)

// 1：公司治理 governance，2：公司经营 management，3：劳动人事 personnel，4：知识产权 ipr, 100: risk 涉诉风险
export const analysisTypes = {
  governance: 1,
  management: 2,
  personnel: 3,
  ipr: 4,
  risk: 100
}
